import { defaultTo, get, toString } from 'lodash/fp';
import numeral from 'numeral';

import decodeChallengeEntrySelection from './decodeChallengeEntrySelection';

function decodeChallengeEntry(data) {
  return {
    id: toString(data.id),
    hash: data.selection_hash,
    rank: data.position,
    selections: decodeChallengeEntrySelection(data.selection),
    score: data.fantasy_score,
    winnings: numeral(defaultTo(0, get('prize.label', data))).value()
  };
}

export default decodeChallengeEntry;
